import { useSyncExternalStore } from "react";

// A page registers the filters of ITS context for the Filter drawer (SideDrawer1). Page and drawer are
// siblings under Layout, so they meet through this tiny external store. A registration carries the
// filter CONTEXT it belongs to (see filterContext.js); the drawer only renders a slot whose context
// equals the one computed from the current route + role, so a stale or foreign registration can never
// show Provider filters on a Buyer page.
let slot = null;
const listeners = new Set();
const emit = () => listeners.forEach((l) => l());

export const setDrawerFilters = (next) => { slot = next; emit(); };
export const clearDrawerFilters = (owner) => { if (!owner || slot?.owner === owner) { slot = null; emit(); } };
export const useDrawerFilters = () => useSyncExternalStore((cb) => { listeners.add(cb); return () => listeners.delete(cb); }, () => slot);

export const OPEN_FILTER_DRAWER_EVENT = "elakay:open-filter-drawer";
// A page's FILTERS button opens the ONE drawer (Elakay Navigation) and asks it to bring the filters
// section into view; the drawer consumes the request once it is open.
let focusFilters = false;
export const consumeFilterFocus = () => { const v = focusFilters; focusFilters = false; return v; };
export const openFilterDrawer = () => { focusFilters = true; window.dispatchEvent(new CustomEvent(OPEN_FILTER_DRAWER_EVENT)); };
